// ═══════════════════════════════════════════════════════════════════════════════
// Módulo: Financiamento de Projetos — Configuração de Navegação
// ═══════════════════════════════════════════════════════════════════════════════

import { LayoutDashboard, FileBarChart, Trophy, Shield, AlertTriangle, Settings, Key, FolderOpen } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface FinanciamentoNavItem {
  label: string;
  href: string;
  icon: LucideIcon;
  roles: string[];
}

export interface FinanciamentoNavSection {
  label: string;
  items: FinanciamentoNavItem[];
}

/**
 * Configuração centralizada da árvore de navegação do módulo Financiamento de Projetos.
 * Foco: monitoramento de risco operacional (sem valores financeiros de financiamento).
 */
export const financiamentoNavSection: FinanciamentoNavSection = {
  label: 'FINANCIAMENTO DE PROJETOS',
  items: [
    {
      label: 'Painel Fiduciário',
      href: '/financiamento/painel',
      icon: LayoutDashboard,
      roles: ['instituicao_financeira', 'admin', 'coadmin'],
    },
    {
      label: 'Medições e Execução',
      href: '/financiamento/medicoes',
      icon: FileBarChart,
      roles: ['instituicao_financeira', 'admin', 'coadmin'],
    },
    {
      label: 'Ranking de Contratos',
      href: '/financiamento/ranking',
      icon: Trophy,
      roles: ['instituicao_financeira', 'admin', 'coadmin'],
    },
    {
      label: 'Inteligência de Risco',
      href: '/financiamento/risco',
      icon: Shield,
      roles: ['instituicao_financeira', 'admin', 'coadmin'],
    },
    // {
    //   label: 'Alertas Operacionais',
    //   href: '/financiamento/alertas',
    //   icon: AlertTriangle,
    //   roles: ['instituicao_financeira', 'admin', 'coadmin'],
    // },
    {
      label: 'Meus Contratos',
      href: '/financiamento/meus-contratos',
      icon: FolderOpen,
      roles: ['instituicao_financeira', 'admin', 'coadmin'],
    },
    {
      label: 'Resgatar Convite',
      href: '/financiamento/resgatar-convite',
      icon: Key,
      roles: ['instituicao_financeira', 'admin', 'coadmin'],
    },
    // {
    //   label: 'Administração de Vínculos',
    //   href: '/financiamento/admin',
    //   icon: Settings,
    //   roles: ['admin', 'coadmin'],
    // },
  ],
};

/**
 * Helper: verifica se uma rota pertence ao módulo de financiamento
 */
export const isFinanciamentoRoute = (pathname: string): boolean =>
  pathname.startsWith('/financiamento/');
